// A UNIT'S MONEY AT A GLANCE — one line, not a table.
//
// The retainer and job screens each carried a full invoice history: every row, every
// column, the same data the money screen now holds in a better shape. Two complete
// copies of one list is clutter, and the second copy is the one that goes stale in
// someone's head. What these screens actually need from the money is the STATUS — is
// anything late, is anything still to come in — and the money screen is one click away
// for the breakdown.
//
// THE FIGURES ARE THE SERVER'S, computed by the module that owns the overdue rule
// (calculations/alerts summarizeCharges) from the rows the screen already had. The
// client re-derives nothing: lateness is a business rule, and a screen that decided it
// locally would eventually disagree with the money screen about the same invoice.
//
// `overdue` and `openNotOverdue` are DISJOINT — the same rule the money screen's headers
// follow, so one debt is never stated twice. Late money is not repeated under "still to
// collect"; it is already the worse case of it.
//
// Shown in full even when everything is zero, because "nothing outstanding" is itself
// the answer somebody opened the screen for — except the late figure, which appears only
// when there is one. A red ₪0 is noise.
//
// NOT WHAT WAS INVOICED: both screens that show this already state that figure in their
// revenue tile, and a second copy of it here was the same number twice on one screen.
import he from '../i18n/he';
import Money from './Money';
import MoneyScreenNote from './MoneyScreenNote';

const t = he.collections.board;

export default function MoneyStatus({ money }) {
  if (!money) return null;

  return (
    <div className="card money-status">
      <div className="money-status-figures">
        <span className="muted">
          {t.collectedTotal}: <strong><Money value={money.collected} /></strong>
        </span>
        {/* Only when there is something late. The one figure here that means somebody
            has to act today, so it carries the colour and nothing else does. */}
        {money.overdue > 0 && (
          <span className="muted">
            {t.stateOverdue}: <strong className="num neg"><Money value={money.overdue} /></strong>
          </span>
        )}
        <span className="muted">
          {t.outstanding}: <strong><Money value={money.openNotOverdue} /></strong>
        </span>
      </div>
      <MoneyScreenNote />
    </div>
  );
}
